import {HttpErrorResponse} from '@angular/common/http';
import * as _ from 'lodash-es';
import {MonoTypeOperatorFunction, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

export const parseApiErrorArrayInHttpErrorResponse =
                 <T, E>(): MonoTypeOperatorFunction<T> => {

    const getErrorCodes = (responseJsonString: string): E[] | any => {
        let result: E[];

        try {
            const parsedJson = JSON.parse(responseJsonString);

            if (_.isArray(parsedJson)) {
                result = parsedJson;
            }
        } catch (error) {
            // Do nothing.
        }

        return result;
    };

    return catchError((inputError: HttpErrorResponse | any) => {
        const outputError = inputError instanceof HttpErrorResponse
            ? new HttpErrorResponse({
                error:      getErrorCodes(inputError.error) || inputError.error,
                headers:    inputError.headers,
                status:     inputError.status,
                statusText: inputError.statusText,
                url:        inputError.url
            })
            : inputError;

        return throwError(outputError);
    });
};

export const isApiErrorArray = (error: any): error is any[] =>
    _.isArray(error) && !(error as any[]).some(item => !_.isString(item));

export const apiErrorArrayIncludes = (errorArray: any[] | any, ...errorItems: any[]): boolean =>
    isApiErrorArray(errorArray)
    && errorItems.some(errorItem => errorArray.includes(errorItem));
